<script>
// deprecated
import { LOGIN_URL } from "../meta/variables";
export default {
  mounted() {
    window.location.href = `${LOGIN_URL}?order_code=${this.$route.query.order_code}`;
  },
};
</script>
